import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M250 2.354C113.441 2.354 2.354 113.476 2.354 250.077S113.441 497.799 250 497.799s247.646-111.121 247.646-247.722S386.559 2.354 250 2.354m0 460.056c-117.104 0-212.268-95.193-212.268-212.333S132.896 37.743 250 37.743s212.268 95.194 212.268 212.334S367.104 462.41 250 462.41m-21.934-347.694L334.2 238.577c5.66 6.545 5.66 16.454 0 22.999L228.066 385.437c-6.368 7.435-17.514 8.319-24.94 1.948-7.433-6.37-8.316-17.518-1.948-24.948l96.229-112.36-96.229-112.362c-6.368-7.434-5.485-18.583 1.948-24.953 3.362-2.83 7.426-4.247 11.496-4.247 4.953 0 9.906 2.124 13.444 6.195z",
      style: {"transform-box":"fill-box","transform-origin":"50% 50%"},
      transform: "rotate(180 0 0)"
    }, null, -1)
  ])))
}
export default { render: render }